import { Link } from 'react-router-dom';
import PageLayout from '@/components/feature/PageLayout';

export default function NotFound() {
  return (
    <PageLayout>
      <div className="min-h-[70vh] flex items-center justify-center pt-16">
        <div className="text-center px-4">
          <p className="text-7xl font-heading font-bold text-foreground-200 mb-4">404</p>
          <h1 className="text-xl font-heading font-semibold text-foreground-900 mb-3">页面未找到</h1>
          <p className="text-sm text-foreground-500 mb-8 max-w-md mx-auto">
            您访问的页面不存在或已被移除，请检查网址是否正确。
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-md hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
          >
            <i className="ri-home-line text-base w-4 h-4 flex items-center justify-center"></i>
            返回首页
          </Link>
        </div>
      </div>
    </PageLayout>
  );
}